import { render, staticRenderFns } from "./B2bInterworking.vue?vue&type=template&id=2c3d3101&scoped=true"
import script from "./B2bInterworking.vue?vue&type=script&lang=js"
export * from "./B2bInterworking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3d3101",
  null
  
)

export default component.exports